import * as React from 'react';
// @ts-expect-error
import {withRouter, ContextRouter} from 'react-router-dom';

import {Button} from 'shells/button/button';
import {Header} from 'shells/typography/header';
import {Subheader} from 'shells/typography/subheader';

import styles from './reset-success-form.module.css';

type Props = ContextRouter;

export function ResetSuccessFormComponent(props: Props) {
    return (
        <>
            <Header>Password set!</Header>
            <div className={styles.text}>
                <Subheader>Use your new password the next time you log in to Nutshell</Subheader>
            </div>
            <div className={styles.button}>
                <Button
                    // @ts-expect-error
                    onClick={() => {
                        props.history.push('/auth');
                    }}
                    variant='primary'
                    size='xlarge'
                    isFullWidth={true}
                >
                    Log in
                </Button>
            </div>
        </>
    );
}

// @ts-expect-error
export const ResetSuccessForm = withRouter<Record<any, any>>(ResetSuccessFormComponent);
